<template>
  <div class="home-page">
    <!-- 头部导航 -->
    <Header />

    <!-- 轮播Banner -->
    <Banner />

    <!-- 公司简介 -->
    <company-intro />

    <!-- 课程优势 -->
    <course-advantages />

    <!-- 就业数据 -->
    <employment-data />

    <!-- 页脚 -->
    <Footer />

    <!-- 固定操作按钮 -->
    <FixedActions />
  </div>
</template>

<script setup>
import Header from '../components/AppHeader.vue'
import Banner from '../components/AppBanner.vue'
import CompanyIntro from '../components/CompanyIntro.vue'
import EmploymentData from '../components/EmploymentData.vue'
import CourseAdvantages from '../components/CourseAdvantages.vue'
import FixedActions from '../components/FixedActions.vue'
import Footer from '../components/AppFooter.vue'

</script>

<style scoped>

</style>
